module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "epi"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_c('i', [_vm._v("Both Miss Eckhart and Virgie Rainey were human beings terribly at large, roaming on the face of the earth. And there were others of them—human beings, roaming, like lost beasts.")])]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_vm._v("—EUDORA WELTY, “June Recital”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f708d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tama_9781571318879_oeb_epi_r1.vue
// module id = 72
// module chunks = 0